var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.8234C16.8333 13.1254 15.6667 14.4274 14.5 15.7297C13.5927 15.7297 12.6851 15.7297 11.7778 15.7297C10.8705 16.4865 9.96283 17.2432 9.05556 18C8.66667 18 8.27778 18 7.88889 18C7.88889 17.2432 7.88889 16.4865 7.88889 15.7297C6.59272 15.7297 5.29617 15.7297 4 15.7297C4 12.918 4 10.1059 4 7.29416C4.56583 6.19611 5.13128 5.09805 5.69711 4C9.79794 4 13.8992 4 18 4C18 6.60778 18 9.21557 18 11.8234Z",
    fill: "#7E57C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 11.3288C16.1851 12.039 15.5372 12.7492 14.8889 13.4595C13.9816 13.4595 13.0739 13.4595 12.1667 13.4595C11.2594 14.2162 10.3517 14.973 9.44445 15.7297C9.44445 14.973 9.44445 14.2162 9.44445 13.4595C8.40728 13.4564 7.3705 13.4534 6.33334 13.4504C6.33334 10.6784 6.33334 7.90676 6.33334 5.13514C9.83334 5.13514 13.3333 5.13514 16.8333 5.13514C16.8333 7.19957 16.8333 9.264 16.8333 11.3288Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.4054H9.83334V11.1892H11V7.4054Z",
    fill: "#7E57C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.4054H13.3333V11.1892H14.5V7.4054Z",
    fill: "#7E57C2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/Twitch.ead7bb25920e4be4ebdae4a71bcf1343.svg";
export { ForwardRef as ReactComponent };